import React from "react";


export const IdColumnFormatter = (  cellContent, row, rowIndex, { openEditOrderPage}) => (
      <a onClick={() => openEditOrderPage(cellContent)} className="text-primary"> {cellContent}</a>
);